/** Matches promotions RebateStatusKind  */
export enum RebateStatus {
  Active = "Active",
  Expired = "Expired",
  Inactive = "Inactive",
  Upcoming = "Upcoming",
  Previewing = "Previewing",
}
